import { render, staticRenderFns } from "./RevisionSearch.vue?vue&type=template&id=70c54976&"
import script from "./RevisionSearch.vue?vue&type=script&lang=js&"
export * from "./RevisionSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports